import { useQuery } from '@tanstack/react-query';
import { verbund, type VerbundStatus } from '../api';
import { useAuth } from '../contexts/AuthContext';
import { mayAccess } from '../routeAccess';

/**
 * Der sichtbare Name des Verlagsverbunds.
 *
 * Maßgeblich ist das Backend (`backend/src/lib/netz.ts`, übersteuerbar mit der
 * Einstellung `VERBUND_NETZ_NAME`); es liefert den Namen in
 * `GET /api/verbund/status`. Die Vorgabe hier ist nur der Platzhalter, bis die
 * Antwort da ist — und für Rollen, die die Statusroute nicht abfragen dürfen.
 * Sie muss zur Vorgabe im Backend passen; an anderer Stelle im Frontend steht
 * der Name nicht.
 */
export const NETZ_NAME_VORGABE = 'Fediverse';

/** Pfad der Verbund-Seite — technisch, ohne den Namen. */
export const VERBUND_PFAD = '/verbund';

/** Status der Anbindung; nur für Rollen, die den Verbund sehen dürfen. */
export function useVerbundStatus() {
  const { user } = useAuth();
  const darf = mayAccess(VERBUND_PFAD, user?.role);
  return useQuery<VerbundStatus>({
    queryKey: ['verbund', 'status'],
    queryFn: verbund.status,
    enabled: darf,
    staleTime: 60_000,
  });
}

export function useNetzName(): string {
  return useVerbundStatus().data?.netzName ?? NETZ_NAME_VORGABE;
}
